<template>
  <div class="w-full flex items-center justify-between gap-[16px]">
    <div class="w-full flex flex-col gap-[6px]">
      <div class="PC_Body1-SB text-[#9B237B] break-words sm:truncate">
        {{ title }}
      </div>

      <div class="break-words whitespace-normal">
        <span
          v-for="(format, idx) in format"
          :key="idx"
          :class="[
            format.type === 'text'
              ? 'PC_Body2-R text-[#1F1D1F]'
              : 'PC_Body2-SB text-[#1F1D1F]',
            'break-words mr-[3px]',
          ]"
        >
          {{ format.content }}
        </span>
      </div>
    </div>
    <div
      v-if="payload.show_details"
      class="w-[98px] min-w-[98px] h-[42px] flex items-center justify-center flex-nowrap gap-[4px] p-[16px] rounded-[6px] border-[1px] border-solid border-[#9B237B] bg-[#FBEFF8] hover:bg-[#EECCE7] text-[#9B237B] cursor-pointer"
      @click="() => detail(payload)"
    >
      <span class="ButtonS"> รายละเอียด </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: String, default: "" },
  format: { type: Array, default: () => [] },
  payload: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["detail"]);

const detail = (p) => emit("detail", p);
</script>

<style lang="scss" scoped>
.ButtonS {
  color: #9b237b;
  text-align: center;
  /* Button/s */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}
</style>
